import {ActionTree, Module} from 'vuex';
import {RootState} from '@/store/types';
import {RequestState} from '@/store/requeststate/types';
import axios, {AxiosResponse} from 'axios';
import firebase from 'firebase';

export interface GetRequest {
    path: string;
    params: {[key: string]: string};
}

export interface PostRequest {
    path: string;
    params: {[key: string]: string};
    data: {};
}

function createUrl(path: string, params: {[key: string]: string}): string {
    let paramsStr = '';
    for (const key of Object.keys(params)) {
        if (paramsStr === '') {
            paramsStr += '?';
        } else {
            paramsStr += '&';
        }
        const value = params[key];
        paramsStr += `${key}=${value}`;
    }
    return `${process.env.VUE_APP_API_URL}/${path}${paramsStr}`;
}

export const actions: ActionTree<RequestState, RootState> = {
    get: async ({state}, req: GetRequest) => {
        const url = createUrl(req.path, req.params);
        const currentUser = firebase.auth().currentUser;
        if (!currentUser) {
            return null;
        }
        let token = await currentUser.getIdToken();
        const res: AxiosResponse = await axios.get(url, {
            headers: {Authorization: `Bearer ${token}`},
        });
        return res.data;
    },
    post: async ({state}, req: PostRequest) => {
        const url = createUrl(req.path, req.params);
        const currentUser = firebase.auth().currentUser;
        if (!currentUser) {
            return null;
        }
        let token = await currentUser.getIdToken();
        const res: AxiosResponse = await axios.post(url, req.data, {
            headers: {Authorization: `Bearer ${token}`},
        });
        return res.data;
    },
};

export const requestState: Module<RequestState, RootState> = {
    namespaced: true,
    actions,
};
